"use client";

import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslations } from "next-intl";

export interface TowerChallengerLogoProps {
  /** Display full name or abbreviated 'TC' */
  variant?: "full" | "short" | "responsive";
  /** Size variant */
  size?: "sm" | "md" | "lg";
  showWordMark?: boolean;
}

export function TowerChallengerLogo({
  variant = "responsive",
  size = "md",
  showWordMark = true,
}: TowerChallengerLogoProps) {
  const t = useTranslations();
  const sizeClasses = {
    sm: {
      icon: "w-8 h-8 text-base",
      text: "text-sm",
    },
    md: {
      icon: "w-10 h-10 md:w-[46px] md:h-[46px] text-xl md:text-[1.4rem]",
      text: "text-base min-lg:text-2xl",
    },
    lg: {
      icon: "w-12 h-12 md:w-14 md:h-14 text-2xl md:text-3xl",
      text: "text-xl min-lg:text-2xl",
    },
  };

  const currentSize = sizeClasses[size];

  return (
    <div className="logo flex items-center gap-2.5">
      <div
        className={`logo-icon ${currentSize.icon} bg-gradient-to-br from-[var(--gold)] to-[var(--gold-dark)] rounded-[10px] flex items-center justify-center shadow-[0_4px_12px_rgba(184,134,11,0.3)] border-2 border-[var(--gold-light)]`}
      >
        <Icon
          icon="game-icons:stone-tower"
          className="w-2/3 h-2/3 text-[var(--bg-deep)]"
        />
      </div>
      {showWordMark && (
        <div className="flex flex-col">
          <span
            className={`logo-text font-cinzel font-extrabold ${currentSize.text} tracking-[0.08em] bg-gradient-to-br from-[var(--gold-light)] via-[var(--gold)] to-[var(--gold-dark)] bg-clip-text text-transparent leading-tight`}
          >
            {variant === "full" && t("brand.name")}
            {variant === "short" && "TC"}
            {variant === "responsive" && (
              <>
                <span className="block lg:inline text-tiny md:text-sm min-lg:text-2xl">
                  {t("brand.nameparts1")}
                </span>
                <span className="block lg:inline text-tiny md:text-sm min-lg:text-2xl">
                  {t("brand.nameparts2")}
                </span>
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
}
